
export const Nationalities = [
  {
    Id: 3,
    Name: 'Afghanistan',
    CountryID: 3,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 5,
    Name: 'Albania',
    CountryID: 5,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 49,
    Name: 'Algeria',
    CountryID: 6,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 9,
    Name: 'American Samoa',
    CountryID: 7,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 1,
    Name: 'Andorra',
    CountryID: 8,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 7,
    Name: 'Angola',
    CountryID: 9,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 4,
    Name: 'Anguilla',
    CountryID: 10,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 8,
    Name: 'Argentina',
    CountryID: 13,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 6,
    Name: 'Armenia',
    CountryID: 14,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 11,
    Name: 'Australia',
    CountryID: 16,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 10,
    Name: 'Austria',
    CountryID: 17,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 12,
    Name: 'Azerbaijan',
    CountryID: 18,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 25,
    Name: 'Bahamas',
    CountryID: 19,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 19,
    Name: 'Bahrain',
    CountryID: 20,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 15,
    Name: 'Bangladesh',
    CountryID: 21,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 14,
    Name: 'Barbados',
    CountryID: 22,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 28,
    Name: 'Belarus',
    CountryID: 23,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 16,
    Name: 'Belgium',
    CountryID: 24,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 29,
    Name: 'Belize',
    CountryID: 25,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 21,
    Name: 'Bermuda',
    CountryID: 27,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 26,
    Name: 'Bhutan',
    CountryID: 28,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 23,
    Name: 'Bolivia',
    CountryID: 29,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 13,
    Name: 'Bosnia and Hersegowina',
    CountryID: 31,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 27,
    Name: 'Botswana',
    CountryID: 32,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 24,
    Name: 'Brazil',
    CountryID: 34,
    LanguageID: 11,
    Country: null,
    Language: null,
  },
  {
    Id: 22,
    Name: 'Brunei Darussalam',
    CountryID: 36,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 18,
    Name: 'Bulgaria',
    CountryID: 37,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 17,
    Name: 'Burkina Faso',
    CountryID: 38,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 20,
    Name: 'Burundi',
    CountryID: 39,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 91,
    Name: 'Cambodia',
    CountryID: 40,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 37,
    Name: 'Cameroon',
    CountryID: 41,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 30,
    Name: 'Canada',
    CountryID: 2,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 42,
    Name: 'Cape Verde',
    CountryID: 43,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 31,
    Name: 'Central African Republic',
    CountryID: 45,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 167,
    Name: 'Chad',
    CountryID: 46,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 36,
    Name: 'Chile',
    CountryID: 47,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 38,
    Name: 'China',
    CountryID: 48,
    LanguageID: 2,
    Country: null,
    Language: null,
  },
  {
    Id: 39,
    Name: 'Colombia',
    CountryID: 51,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 32,
    Name: 'Congo',
    CountryID: 53,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 35,
    Name: 'Cook Islands',
    CountryID: 55,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 40,
    Name: 'Costa Rica',
    CountryID: 56,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 34,
    Name: 'Cote Divoire',
    CountryID: 57,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 76,
    Name: 'Croatia (local name: Hrvatska)',
    CountryID: 58,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 41,
    Name: 'Cuba',
    CountryID: 59,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 43,
    Name: 'Cyprus',
    CountryID: 61,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 44,
    Name: 'Czech Republic',
    CountryID: 62,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 47,
    Name: 'Denmark',
    CountryID: 63,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 46,
    Name: 'Djibouti',
    CountryID: 64,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 48,
    Name: 'Dominican Republic',
    CountryID: 66,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 171,
    Name: 'East Timor',
    CountryID: 224,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 50,
    Name: 'Ecuador',
    CountryID: 67,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 52,
    Name: 'Egypt',
    CountryID: 68,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 164,
    Name: 'El Salvador',
    CountryID: 69,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 60,
    Name: 'England',
    CountryID: 237,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 51,
    Name: 'Estonia',
    CountryID: 72,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 54,
    Name: 'Ethiopia',
    CountryID: 73,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 57,
    Name: 'Falkland Islands (Malvinas)',
    CountryID: 74,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 56,
    Name: 'Fiji',
    CountryID: 76,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 55,
    Name: 'Finland',
    CountryID: 77,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 58,
    Name: 'France',
    CountryID: 78,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 63,
    Name: 'French Guiana',
    CountryID: 79,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 138,
    Name: 'French Polynesia',
    CountryID: 80,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 59,
    Name: 'Gabon',
    CountryID: 82,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 67,
    Name: 'Gambia',
    CountryID: 83,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 62,
    Name: 'Georgia',
    CountryID: 84,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
  {
    Id: 45,
    Name: 'Germany',
    CountryID: 85,
    LanguageID: 6,
    Country: null,
    Language: null,
  },
  {
    Id: 64,
    Name: 'Ghana',
    CountryID: 86,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 65,
    Name: 'Gibraltar',
    CountryID: 87,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 69,
    Name: 'Greece',
    CountryID: 88,
    LanguageID: 5,
    Country: null,
    Language: null,
  },
  {
    Id: 66,
    Name: 'Greenland',
    CountryID: 89,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 61,
    Name: 'Grenada',
    CountryID: 90,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 71,
    Name: 'Guam',
    CountryID: 92,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 70,
    Name: 'Guatemala',
    CountryID: 93,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 68,
    Name: 'Guinea',
    CountryID: 95,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 72,
    Name: 'Guinea-Bissau',
    CountryID: 96,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 73,
    Name: 'Guyana',
    CountryID: 97,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 77,
    Name: 'Haiti',
    CountryID: 98,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 183,
    Name: 'Holy See (Vatican City State)',
    CountryID: 100,
    LanguageID: 8,
    Country: null,
    Language: null,
  },
  {
    Id: 75,
    Name: 'Honduras',
    CountryID: 101,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 74,
    Name: 'Hong Kong',
    CountryID: 102,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 78,
    Name: 'Hungary',
    CountryID: 103,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 85,
    Name: 'Iceland',
    CountryID: 104,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 82,
    Name: 'India',
    CountryID: 105,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 79,
    Name: 'Indonesia',
    CountryID: 106,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 84,
    Name: 'Iran (Islamic Republic Of)',
    CountryID: 107,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 83,
    Name: 'Iraq',
    CountryID: 108,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 80,
    Name: 'Ireland',
    CountryID: 109,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 194,
    Name: 'Iritriya',
    CountryID: null,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 81,
    Name: 'Israel',
    CountryID: 111,
    LanguageID: 7,
    Country: null,
    Language: null,
  },
  {
    Id: 86,
    Name: 'Italy',
    CountryID: 112,
    LanguageID: 8,
    Country: null,
    Language: null,
  },
  {
    Id: 87,
    Name: 'Jamaica',
    CountryID: 113,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 89,
    Name: 'Japan',
    CountryID: 114,
    LanguageID: 9,
    Country: null,
    Language: null,
  },
  {
    Id: 88,
    Name: 'Jordan',
    CountryID: 116,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 94,
    Name: 'Kazakhstan',
    CountryID: 117,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 90,
    Name: 'Kenya',
    CountryID: 118,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 93,
    Name: 'Kuwait',
    CountryID: 122,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 102,
    Name: 'Latvia',
    CountryID: 125,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 95,
    Name: 'Lebanon',
    CountryID: 126,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 99,
    Name: 'Lesotho',
    CountryID: 127,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 98,
    Name: 'Liberia',
    CountryID: 128,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 103,
    Name: 'Libyan Arab Jamahiriya',
    CountryID: 129,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 96,
    Name: 'Liechtenstein',
    CountryID: 130,
    LanguageID: 6,
    Country: null,
    Language: null,
  },
  {
    Id: 100,
    Name: 'Lithuania',
    CountryID: 131,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 101,
    Name: 'Luxembourg',
    CountryID: 132,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 113,
    Name: 'Macau',
    CountryID: 133,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 109,
    Name: 'Macedonia',
    CountryID: 134,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 107,
    Name: 'Madegasca',
    CountryID: 135,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 121,
    Name: 'Malasyia',
    CountryID: 137,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 119,
    Name: 'Malawi',
    CountryID: 136,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 118,
    Name: 'Maldives',
    CountryID: 138,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 110,
    Name: 'Mali',
    CountryID: 139,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 116,
    Name: 'Malta',
    CountryID: 140,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 108,
    Name: 'Marshall Islands',
    CountryID: 141,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 114,
    Name: 'Martinique',
    CountryID: 142,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 115,
    Name: 'Mauritania',
    CountryID: 143,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 117,
    Name: 'Mauritius',
    CountryID: 144,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 120,
    Name: 'Mexico',
    CountryID: 146,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 106,
    Name: 'Moldova',
    CountryID: null,
    LanguageID: null,
    Country: null,
    Language: null,
  },
  {
    Id: 105,
    Name: 'Monaco',
    CountryID: 149,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 112,
    Name: 'Mongolia',
    CountryID: 150,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 197,
    Name: 'Montenegro',
    CountryID: 151,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 104,
    Name: 'Morocco',
    CountryID: 153,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 122,
    Name: 'Mozambique',
    CountryID: 154,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 111,
    Name: 'Myanmar',
    CountryID: 155,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 123,
    Name: 'Namibia',
    CountryID: 156,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 132,
    Name: 'Nauru',
    CountryID: 157,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 131,
    Name: 'Nepal',
    CountryID: 158,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 129,
    Name: 'Netherlands',
    CountryID: 159,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 124,
    Name: 'New Caledonia',
    CountryID: 160,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 133,
    Name: 'New Zealand',
    CountryID: 161,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 128,
    Name: 'Nicaragua',
    CountryID: 162,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 125,
    Name: 'Niger',
    CountryID: 163,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 127,
    Name: 'Nigeria',
    CountryID: 164,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 126,
    Name: 'Norfolk Island',
    CountryID: 166,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 130,
    Name: 'Norway',
    CountryID: 168,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 134,
    Name: 'Oman',
    CountryID: 169,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 141,
    Name: 'Pakistan',
    CountryID: 170,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 136,
    Name: 'Panama',
    CountryID: 173,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 139,
    Name: 'Paoua New Guinea',
    CountryID: 174,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 145,
    Name: 'Paraguay',
    CountryID: 175,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 137,
    Name: 'Peru',
    CountryID: 176,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 140,
    Name: 'Philippines',
    CountryID: 177,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 142,
    Name: 'Poland',
    CountryID: 179,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 144,
    Name: 'Portugal',
    CountryID: 180,
    LanguageID: 11,
    Country: null,
    Language: null,
  },
  {
    Id: 143,
    Name: 'Puerto Rico',
    CountryID: 181,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 146,
    Name: 'Qatar',
    CountryID: 182,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 147,
    Name: 'Romania',
    CountryID: 184,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 149,
    Name: 'Russian Federation',
    CountryID: 185,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
  {
    Id: 150,
    Name: 'Rwanda',
    CountryID: 186,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 92,
    Name: 'Saint Kitts and Nevis',
    CountryID: 189,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 188,
    Name: 'Samoa',
    CountryID: 194,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 160,
    Name: 'San Marino',
    CountryID: 195,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 151,
    Name: 'Saudi Arabia',
    CountryID: 197,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 161,
    Name: 'Senegal',
    CountryID: 198,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 148,
    Name: 'SERBIA',
    CountryID: 205,
    LanguageID: 14,
    Country: null,
    Language: null,
  },
  {
    Id: 152,
    Name: 'Seychelles',
    CountryID: 200,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 159,
    Name: 'Sierra Leone',
    CountryID: 201,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 155,
    Name: 'Singapore',
    CountryID: 202,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 158,
    Name: 'Slovakia (Slovak Republic)',
    CountryID: 204,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
  {
    Id: 157,
    Name: 'Slovenia',
    CountryID: 205,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
  {
    Id: 162,
    Name: 'Somalia',
    CountryID: 207,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 191,
    Name: 'South Africa',
    CountryID: 208,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 195,
    Name: 'South Korea',
    CountryID: 120,
    LanguageID: null,
    Country: null,
    Language: null,
  },
  {
    Id: 53,
    Name: 'Spain',
    CountryID: 211,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 97,
    Name: 'Sri Lanka',
    CountryID: 212,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 156,
    Name: 'St. Helena',
    CountryID: 188,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 153,
    Name: 'Sudan',
    CountryID: 213,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 163,
    Name: 'Suriname',
    CountryID: 214,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 166,
    Name: 'Swaziland',
    CountryID: 216,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 154,
    Name: 'Sweden',
    CountryID: 217,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 33,
    Name: 'Switzerland',
    CountryID: 218,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 165,
    Name: 'Syrian Arab Republic',
    CountryID: 219,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 176,
    Name: 'Taiwan',
    CountryID: 220,
    LanguageID: null,
    Country: null,
    Language: null,
  },
  {
    Id: 170,
    Name: 'Tajikistan',
    CountryID: 221,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 177,
    Name: 'Tanzania',
    CountryID: null,
    LanguageID: null,
    Country: null,
    Language: null,
  },
  {
    Id: 169,
    Name: 'Thailand',
    CountryID: 223,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 168,
    Name: 'Togo',
    CountryID: 225,
    LanguageID: 4,
    Country: null,
    Language: null,
  },
  {
    Id: 175,
    Name: 'Trinidad and Tobago',
    CountryID: 228,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 173,
    Name: 'Tunisia',
    CountryID: 229,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 174,
    Name: 'Turkey',
    CountryID: 230,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 172,
    Name: 'Turkmenistan',
    CountryID: 231,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 179,
    Name: 'Uganda',
    CountryID: 234,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 178,
    Name: 'Ukraine',
    CountryID: 235,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
  {
    Id: 2,
    Name: 'United Arab Emirates',
    CountryID: 236,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 196,
    Name: 'United Kingdom of Great Britain and Northern Ireland',
    CountryID: 237,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 180,
    Name: 'United States',
    CountryID: 1,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 181,
    Name: 'Uruguay',
    CountryID: 240,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 182,
    Name: 'Uzbekistan',
    CountryID: 241,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 187,
    Name: 'Vanuatu',
    CountryID: 242,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 184,
    Name: 'Venezuela',
    CountryID: 243,
    LanguageID: 13,
    Country: null,
    Language: null,
  },
  {
    Id: 186,
    Name: 'Viet Nam',
    CountryID: 244,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 185,
    Name: 'Virgin Islands (British)',
    CountryID: 245,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 135,
    Name: 'xxOthers ',
    CountryID: null,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 189,
    Name: 'Yemen',
    CountryID: 249,
    LanguageID: 1,
    Country: null,
    Language: null,
  },
  {
    Id: 190,
    Name: 'Yugoslavia',
    CountryID: null,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 192,
    Name: 'Zambia',
    CountryID: 250,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 193,
    Name: 'Zimbabwe',
    CountryID: 251,
    LanguageID: 3,
    Country: null,
    Language: null,
  },
  {
    Id: 198,
    Name: 'North Korea',
    CountryID: 120,
    LanguageID: 16,
    Country: null,
    Language: null,
  },
  {
    Id: 199,
    Name: 'Kyrgyzstan',
    CountryID: 123,
    LanguageID: 12,
    Country: null,
    Language: null,
  },
];

export const getNationalityNameById = ({ NationalityId = 0, CountryID = 0 }) =>
  Nationalities.find((n) => n.Id == NationalityId || n.CountryID == CountryID)?.Name || "Not Specified";

export const getNationalities = () => Nationalities;
